import React, { FC, useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import PractitionerInfoCard from "./practitioner-info-card";
import LoadingBox from "./loading-box";
import { toast } from "sonner";
import { isNullOrAll } from "lib/utils/util";
import SimpleModal from "./simple-modal";
import PractitionerProfileCard from "../profile/practitioner-profile-card";
import usePractitioner from "lib/hooks/usePractitioner";

interface PractitionerListProps extends React.HTMLProps<HTMLDivElement> {
  practitionersDetails: PractitionerDetails[];
  selectedTherapyId?: string;
  selectedClinicId?: string;
  isLoading?: boolean;
  onBookAppointment: (practitionerId: string) => void;
}

const PractitionerList: FC<PractitionerListProps> = (
  {
    isLoading,
    practitionersDetails,
    selectedTherapyId,
    selectedClinicId,
    onBookAppointment,
  },
  props
) => {

  const {
    getPractitionerProfilePic,
    getPractitionerTherapies
  } = usePractitioner();
  const [selectedPractitioner, setSelectedPractitioner] = useState<PractitionerDetails | null>(null);

  const [profilePicUrl, setProfilePicUrl] = useState<string | null>(null);
  const [practitionerTherapies, setPractitionerTherapies] = useState<PractitionerTherapy[]>([]);


  useEffect(() => {
    if (selectedPractitioner) {
      getPractitionerProfilePic(selectedPractitioner?.id, setProfilePicUrl);
      getPractitionerTherapies(selectedPractitioner?.id, setPractitionerTherapies);
    } else {
      setPractitionerTherapies([]);
      setProfilePicUrl(null);
    }
  }, [selectedPractitioner])

  const handleBookAppointmentClick = (practitionerId: string) => {
    if (isNullOrAll(practitionerId)) {
      toast.error("Please select a practitioner.");
      return;
    }

    if (isNullOrAll(selectedClinicId)) {
      toast.error("Please select a clinic.");
      return;
    }

    if (isNullOrAll(selectedTherapyId)) {
      toast.error("Please select a therapy.");
      return;
    }

    onBookAppointment(practitionerId);
  };

  return (
    <Container {...props}>
      {isLoading ? (
        <LoadingBox />
      ) : (
        <Row className="gy-4 justify-content-center justify-content-lg-start">
          {(practitionersDetails ?? []).map((practitioner) => (
            <Col xs={12} key={practitioner?.id} className="p-0">
              <PractitionerInfoCard
                practitioner={practitioner}
                practitionerTherapies={practitioner?.therapies ?? []}
                onBookAppointmentClick={() =>
                  handleBookAppointmentClick(practitioner?.id ?? "")
                }
                onProfileViewClick={setSelectedPractitioner}
              />
            </Col>
          ))}
        </Row>
      )}
      <SimpleModal
        open={!!selectedPractitioner}
        close={() => setSelectedPractitioner(null)}
        title="Practitioner Profile"
      >
        <PractitionerProfileCard
          //isLoading={therapiesLoading || practitionerLoading}
          practitionerDetails={selectedPractitioner}
          profilePicUrl={profilePicUrl}
          practitionerTherapies={practitionerTherapies ?? []}
          therapies={selectedPractitioner?.therapies ?? []}
          isEditable={false}
        />
      </SimpleModal>
    </Container>
  );
};

export default PractitionerList;
